module.exports = __webpack_public_path__ + "img/en-flag.ac002e83.png";